module.exports = __webpack_public_path__ + "static/media/Cats eyes 10_TYSKA-mixdown.8885d797.mp3";